import { translate, translateFormatter } from '@manomano-internal/i18n/esm/placeholders';
export const {
  containerTitle,
  codeCopied,
  conditions
} = translate({
  "containerTitle": "Exclusive advantage",
  "codeCopied": "Copied",
  "conditions": "View conditions"
});
export const copyCode = translateFormatter<{
  code: string;
}>("Copy {code}", undefined, undefined, "en");